import { styled } from "@theme/stitches.config"

export const Spacer = styled("div", {
    width: "100%",
    height: "auto",
    backgroundColor: "transparent",
    variants: {
        size: {
            small: {
                height: 60
            },
            medium: {
                height: 120
            },
            large: {
                height: 180
            }
        }
    }
})
